import React from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import * as _R from 'ramda';  // used 0.04kb
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

import {DialogBoxMedium} from '../common/dialog.medium';

export const CityComponent= (props) => { 
        return (
            <>
               <div className={'section-main'}>
                <div className={'listSubHeader'}>
                    <Typography component="h2" className={'section-title'} variant="button" display="block" gutterBottom color="primary">Cities</Typography>
                    {(props.EditPermission) &&
                    <Tooltip title="Add City" aria-label="add">
                        <Fab size="small" color="default" aria-label="add" className={'fab-outline'} >
                            <AddIcon onClick={props.OnAddCityClick}/>
                        </Fab>
                    </Tooltip>
                    }
                </div>
                <div className={'section-content roles-table'}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>State</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.Cities.map((ct,i) =>    
                            <TableRow hover>
                                <TableCell>{ct.name}</TableCell>   
                                <TableCell>{ct.state_name}</TableCell>
                                <TableCell align="right">
                                    {(props.EditPermission) &&
                                    <Tooltip title="Edit" aria-label="edit">
                                        <IconButton className={'action-btn'} edge="end" aria-label="Edit">
                                            <EditIcon fontSize="small" onClick={props.EditCityClick(ct.id)} />
                                        </IconButton>
                                    </Tooltip>                
                                    }
                                </TableCell>
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                </div>
                
                {props.PopupType === 'add' &&
                <DialogBoxMedium 
                    Open= { props.Open }  
                    Cancel = { props.OnClose }
                    Title = { props.IsEditable ? 'Edit City' : 'Add City' }
                    OnSubmit = { props.HandleSubmit }
                    Content = { <DialogContent FormProps = { props }/> }
                />
                }
              
            </>
        )
}

const DialogContent = (props) => {
    const { FormFields,HandleOnChange,Errors } = props.FormProps;
    return (
        <form className="form-fullwidth" onSubmit={props.OnSubmit}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                    <FormControl>
                        <TextField variant="standard"
                            required
                            id = "name"
                            name = "name"
                            label = "Name"
                            InputLabelProps = {{
                                shrink: true,
                            }}
                            value = { _R.type(FormFields) !== 'undefined' ? FormFields.name : '' }
                            onChange = { HandleOnChange }
                            error = { Errors.name && true }
                            helperText = { Errors.name }
                        />
                    </ FormControl>
                    <FormControl variant="standard">
                        <InputLabel htmlFor="state">State</InputLabel>
                        <Select
                            required
                            value = { _R.type(FormFields) !== 'undefined' ? FormFields.state_id : '' }           
                            onChange={HandleOnChange}
                            inputProps={{
                                name: 'state_id',
                                id: 'state_id',
                            }}>
                            {props.FormProps.States.map((st, i) =>
                                <MenuItem value={st.id} key={'sub-type-'+i}>{st.name}</MenuItem>
                            )}
                        </Select>
                       {Errors.state_id && <FormHelperText>{Errors.state_id}</FormHelperText> }
                    </ FormControl>
                </Grid>               
            </Grid>
        </form>
    )
}
